/**
 * 메일 제목 만들기 — **한 곳에서만** (v2.125.0 · 2026-09-04 · 사용자 요청)
 *
 * 「[견적서 송부] 프로젝트명」 처럼 **분류를 대괄호로 묶고** 뒤에 이름을 붙인다.
 * 예전에는 `견적서 송부 — 프로젝트명` 이었다(가운뎃줄표). 받는 쪽 메일함에서 분류가
 * 눈에 먼저 들어오게 바꾼 것이다.
 *
 * ⭐제목을 만드는 화면이 열 곳이 넘는다 — 모양을 각자 적으면 다음에 바꿀 때 **한두 곳이 남는다.**
 *   그래서 모양은 여기 한 곳에만 있고, 화면은 「분류」와 「이름」만 넘긴다.
 *   (`scripts/check-mail-subject.mjs` 가 화면에서 제목 모양을 직접 짓는 것을 막는다)
 */

/**
 * @param kind 대괄호 안에 들어갈 분류 — 「견적서 송부」·「발주서 송부」…
 * @param name 뒤에 붙일 이름 — 프로젝트명·문서번호. 없으면 대괄호만 남는다.
 */
export function mailSubject(kind: string, name?: string | null): string {
  const k = kind.trim();
  const n = (name ?? '').trim();
  return n ? `[${k}] ${n}` : `[${k}]`;
}
